/* src/app/forms/produtos/produto-insert-edit-form/produto-insert-edit-form.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 20px;
  border-radius: 30px;
  border: 1px solid gray;
}
/*# sourceMappingURL=produto-insert-edit-form.component.css.map */
